import React, { SyntheticEvent, useRef, useState } from 'react';
import { Button, Grid, Input, InputLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useField, useFormikContext } from 'formik';
import BaseTextField from '@material-ui/core/TextField';

import { BUTTON_COLOR, BUTTON_VARIANT, TEXT_FIELD_COLOR } from '../../enum/formProps';
import { MultimediaValues } from '../../../../features/multimedia/model/multimediaModel';
import './Upload.scss';

interface UploadProps {
  label: string;
  name: string;
  color?: TEXT_FIELD_COLOR;
  hideLabel?: boolean;
}

const Upload: React.FC<UploadProps> = ({ label, hideLabel, ...props }) => {
  const { setFieldValue } = useFormikContext<MultimediaValues>();
  const { t } = useTranslation();
  const [field, meta] = useField(props);
  const isError = !!(meta.error && meta.touched);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef<HTMLInputElement>();

  return (
    <Grid container spacing={0} className="Upload-Container">
      {!hideLabel && (
        <Grid item xs={4} md={3} lg={2} xl={1}>
          <InputLabel className="Upload-InputLabel" error={isError}>
            {t(label)}
          </InputLabel>
        </Grid>
      )}
      <Grid item xs={8} md={9} lg={10} xl={11}>
        <Grid container spacing={0}>
          <Grid item xs={4} md={3} lg={2} xl={1}>
            <label htmlFor={props.name}>
              <Input
                ref={fileInputRef}
                className="Upload-Input"
                type="file"
                id={props.name}
                {...field}
                {...props}
                error={isError}
                value={undefined}
                onChange={(event: SyntheticEvent) => {
                  let inputElement = event.currentTarget as HTMLInputElement;

                  if (inputElement.files) {
                    let file = inputElement.files[0];

                    setFileName(file?.name ?? '');
                    setFieldValue(props.name, file);
                  }
                }}
              />
              <Button
                className="Upload-Button"
                variant={BUTTON_VARIANT.CONTAINED}
                color={BUTTON_COLOR.DEFAULT}
                component="span"
              >
                {t('button.select')}
              </Button>
            </label>
          </Grid>
          <Grid item xs={8} md={9} lg={10} xl={11}>
            <BaseTextField
              value={fileName}
              disabled={true}
              className="Upload-BaseTextField"
              error={isError}
              fullWidth
              helperText={t(meta.error ?? '')}
              color={props.color}
              onClick={() => {
                fileInputRef?.current?.click();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Upload;
